import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";
import { IFacility, IqueryParams, CreateFacility } from "../../config/types";

interface ExportParams extends IqueryParams<{
  district_name?: string;
  facility_name?: string;
}> {
  file_format: 'pdf' | 'csv';
}

const createFacility = async (data: CreateFacility) => {
  return apiService.apiRequest<IFacility>("post", `facilities`, data);
};

const getFacilities = async (queryParams?: IqueryParams<{
  district_name?: string;
  facility_name?: string;
}>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IFacility[]>("get", `facilities${query}`);
};

const getFacility = async (facility_id: string) => {
  return apiService.apiRequest<IFacility>("get", `facilities/${facility_id}`);
};

const updateFacility = async (facility_id: string, data: CreateFacility) => {
  return apiService.apiRequest<IFacility>("put", `facilities/${facility_id}`, data);
};

const deleteFacility = async (facility_id: string) => {
  return apiService.apiRequest<any>("delete", `facilities/${facility_id}`);
};

const restoreFacility = async (facility_id: string) => {
  return apiService.apiRequest<IFacility>("get", `facilities/${facility_id}/restore`);
};

const exportFacilities = async (params: ExportParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `facilities/export${query}`
  );
};

export const facilitiesApi = {
  createFacility,
  getFacilities,
  getFacility,
  updateFacility,
  deleteFacility,
  restoreFacility,
  exportFacilities, 
};